import { useEffect, useState } from 'react'
import EventEmitter, {
  SHOW_ORDER_BUSINESS_CREDIT_REPORT,
} from '../../../helpers/EventEmitter'
import { PopupAction } from '../PopupAction'
import { Content } from './Content'
import './i18n'

export const PopupBusinessCreditReport = () => {
  const [isShow, setIsShow] = useState(false)

  const handleClose = () => {
    setIsShow(false)
  }

  useEffect(() => {
    const showOrderBusinessCreditReport = (isShow) => {
      setIsShow(isShow)
    }

    EventEmitter.subscribe(
      SHOW_ORDER_BUSINESS_CREDIT_REPORT,
      showOrderBusinessCreditReport,
    )
    return () => {
      EventEmitter.unsubscribe(
        SHOW_ORDER_BUSINESS_CREDIT_REPORT,
        showOrderBusinessCreditReport,
      )
    }
  }, [])

  return (
    <PopupAction
      appendStyle={{
        backgroundColor: '#F3F3F3',
        borderRadius: 4,
        padding: 20,
        width: 800,
      }}
      isShow={isShow}
      title={'common.popup.popupBusinessCreditReport.TITLE'}
      handleClose={handleClose}
    >
      <Content />
    </PopupAction>
  )
}
